<template>
  <div class="sky-product-version-select">
    <div class="select-change-step">
      <div class="child-stage-progress wsp-display-flex-center">
        <div class="child-step-content">
          <div class="navs">
            <ul>
              <li
                :class="
                  `navs-item ${childItem.value === stepValue ? 'active inprogess' : ''}  ${
                    handelIndex === key ? 'handel-view' : ''
                  }  ${activeStageNum > key ? 'progress-done' : 'progress-todo'}  `
                "
                v-for="(childItem, key) in childStep"
                :key="key"
                @click="handelNavItem(childItem, key)"
              >
                {{ childItem.name }}
              </li>
            </ul>
          </div>
          <div class="activite-line">
            <ul>
              <div
                v-for="(childItem, key) in childStep"
                :key="key"
                :class="`navs-item ${handelIndex === key ? 'active' : ''}`"
              ></div>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="select-change-step-content" v-if="childStep.length > 1 && handelStep.id !== 'versionChangeConfirm'">
      <function-table
        ref="select_function_table"
        @changeSelect="viewSelectInfo"
        :productId="handelStep.id"
        :selectFeatureIds="stepPageSelectFeatureIds"
        :parentSelectVersionId="parentSelectVersionId"
        :projectCompetitors="projectCompetitors"
        :params="{ sceneIdList: relationSceneIdList }"
      ></function-table>
    </div>
    <div class="select-change-step-bottom" v-if="handelStep.id !== 'versionChangeConfirm'">
      <div class="wsp-padding-tb-12">
        当前功能列表包含 <span class="bg-3bb113 wsp-padding-lr-6">{{ totalFeatureCont }}</span> 项功能,已选择
        <span class="bg-f13131 wsp-padding-lr-6">{{ selectFeatureCont }}</span> 项功能
      </div>
      <div class="wsp-display-flex select-version-info">
        <div
          v-for="(versionItem, index) in versionList"
          :key="index"
          :class="
            `wsp-width-20 wsp-margin-6 select-version-item wsp-padding-3 ${
              stepSelectVersion && versionItem.id == stepSelectVersion.versionId ? 'handel-active' : ''
            }`
          "
          @click="handelSelectProductVersion(versionItem)"
        >
          <div v-if="versionItem.id !== 'no_version_config'">
            <div v-if="versionItem.hasRecommend" class="select-recommend wsp-icon-recommend bg-f13131"></div>
            <div class="select-version">{{ versionItem.productVersion }}</div>
            <div class="select-support wsp-display-flex wsp-padding-3">
              <div
                class="select-support-rate bg-3bb113 backgroud-color-3bb113"
                :style="`width: ${getRate(versionItem.supportFeatureIds.length, selectFeatureCont)}%;`"
              ></div>
              <div
                class="wsp-icon-vs select-support-vs"
                :style="`left: ${getRate(versionItem.supportFeatureIds.length, selectFeatureCont) - 4}%;top:-5px`"
              ></div>
              <div
                class="select-usupport-rate backgroud-color-f13131"
                :style="`width: ${getRate(versionItem.unSupportFeatureids.length, selectFeatureCont)}%;`"
              ></div>
            </div>
            <div class="select-support-cont wsp-display-flex wsp-padding-3">
              <div class="select-support-rate wsp-width-50 bg-3bb113">
                支持：{{ versionItem.supportFeatureIds.length }}
              </div>
              <div class="select-usupport-rate wsp-width-50 bg-f13131">
                不支持: {{ versionItem.unSupportFeatureids.length }}
              </div>
            </div>
          </div>
          <div v-else class="wsp-display-flex-center font-size-18 wsp-height-100">
            <div>
              <strong>{{ versionItem.productVersion }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="handelStep.id === 'versionChangeConfirm'" class="select-view">
      <div class="wsp-line-height-48 wsp-text-align-center">
        <div class="font-size-28"><strong>确认选择版本</strong></div>
      </div>
      <div class="wsp-border select-info">
        <div class="wsp-display-flex  select-table-header">
          <div class="wsp-width-20 wsp-border-bottom wsp-border-right">产品系列</div>
          <div class="wsp-width-80  wsp-border-bottom ">选择信息</div>
        </div>
        <div v-for="(value, index) in viewSelectVersion" :key="index" class="wsp-display-flex select-table-content ">
          <div class="wsp-width-20  wsp-border-right  wsp-display-flex-center">
            <div>{{ value.serial }}</div>
          </div>
          <div class="wsp-width-80 select-table-content-info">
            <div class="wsp-display-flex">
              <div class="wsp-width-30 wsp-border-bottom wsp-border-right wsp-border-top">功能统计</div>
              <div class="wsp-width-70 wsp-border-bottom ">
                总计<span class="bg-3bb113">{{ value.totalFeatureCont }}</span
                >项功能，选择其中<span class="bg-f13131">{{ value.selectFeatureCont }}</span>
                项功能
              </div>
            </div>
            <div class="wsp-display-flex">
              <div class="wsp-width-30 wsp-border-bottom wsp-border-right">选择产品版本</div>
              <div class="wsp-width-70 wsp-border-bottom">
                <span v-if="value.selectType === 'AUTO'" class="bg-f13131">【推荐选择】</span>
                <span v-else class="bg-3bb113">【手动选择】</span>
                {{ value.productVersion }}
              </div>
            </div>
            <div class="wsp-display-flex">
              <div class="wsp-width-30 wsp-border-right">已选择功能版本支持情况</div>
              <div class="wsp-width-70 wsp-display-flex">
                <div class="wsp-width-50 bg-3bb113">
                  支持：<span>{{ value.supportFeatureIds.length }}</span>
                  <!-- 支持：<span>{{ value }}</span> -->
                </div>
                <div class="wsp-width-50 bg-f13131">
                  不支持：<span>{{ value.unSupportFeatureids.length }}</span>
                  <!-- 不支持：<span>{{ value }}</span> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sky-product-version-select-buttom" style="text-align: center;">
      <el-button
        type="primary"
        class="sky-branch-pattern__add"
        icon="sk-icon-home"
        @click="backToView"
        style="margin-top:5px"
      >
        返回
      </el-button>
      <el-button
        class="sky-branch-pattern__add"
        style="margin-top:5px"
        @click="goPreStep"
        v-if="this.handelIndex !== 0"
      >
        上一步
      </el-button>
      <el-button
        class="sky-branch-pattern__add"
        style="margin-top:5px"
        @click="goNextStep"
        v-if="this.handelIndex !== this.childStep.length - 1"
      >
        下一步
      </el-button>
      <el-button
        type="danger"
        class="sky-branch-pattern__add"
        style="margin-top:5px"
        @click="onConfirm"
        v-if="this.handelIndex === this.childStep.length - 1"
      >
        确认选择
      </el-button>
    </div>
  </div>
</template>

<script>
import { Steps, Step, Button, Tooltip, Input } from 'element-ui'

import FunctionTable from './functionTable'

import { saveTempStepData, getTempStepData } from '@/api/project'

import { relateProduct } from '@/api/scene'

export default {
  name: 'SkyProductVersionSelect',
  components: {
    [Steps.name]: Steps,
    [Step.name]: Step,
    [Button.name]: Button,
    [Input.name]: Input,
    [Tooltip.name]: Tooltip,
    FunctionTable
  },
  props: {
    sceneIdList: {
      type: Array,
      default: () => {
        return []
      }
    },
    projectId: {
      type: String,
      default: () => {
        return null
      }
    },
    selectFeatureIds: {
      type: Array,
      default: () => {
        return []
      }
    },
    projectCompetitors: {
      type: Array,
      default: () => {
        return []
      }
    },
    selectProductInfo: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {},
  created() {
    this.relationSceneIdList = this.sceneIdList
    this.allSelectFeatureIds = this.selectFeatureIds

    getTempStepData({ projectId: this.projectId, flowStatus: 'MDR_SCENE_RESEARCH_PRODUCT_SELECT' }).then(res => {
      if (res.data.content) {
        this.buildInitData(res.data.content)
      }

      this.getInitData()
    })
  },
  beforeDestroy() {},
  data() {
    return {
      stepValue: null,
      relationSceneIdList: [],
      relationProduct: [],
      allSelectFeatureIds: [],
      versionList: [],
      totalFeatureCont: 0,
      selectFeatureCont: 0,
      activeStageNum: 1,
      handelIndex: 0,
      childStep: [],
      handelStep: {},
      stepSelectVersion: {},
      handelSelectVersion: {},
      parentSelectVersionId: [],
      stepPageSelectFeatureIds: [],
      functionParmas: {},
      stepHasRecomment: false,
      viewSelectVersion: [],
      setpHandelSelectVersion: false
    }
  },
  mounted() {},
  destroyed() {},
  methods: {
    buildInitData(resContent) {
      // var tempData = JSON.parse(resContent.data)
      // this.handelIndex = tempData.handelIndex
      // this.activeStageNum = tempData.activeStageNum
      //
      // this.viewSelectVersion = tempData.viewSelectVersion
      // this.activiteViewPage = this.childStep[this.handelIndex]
      // this.reloadData()
    },
    handelNavItem(childNavItem, index) {
      if (index > this.handelIndex) {
        return
      }
      this.handelIndex = index
      this.activeStageNum = index + 1
      this.activiteViewPage = childNavItem
      this.reloadData()
    },
    saveTempChildStepData() {
      let req_params = {
        projectId: this.projectId,
        flowStep: 'MDR_SCENE_RESEARCH_PRODUCT_SELECT',
        data: {
          handelIndex: this.handelIndex,
          activeStageNum: this.activeStageNum,
          viewSelectVersion: this.viewSelectVersion
        }
      }
      saveTempStepData(req_params).then(res => {
        this.$store.dispatch('OpenNotification', {
          message: '暂存信息',
          type: 'success'
        })
      })
    },
    getRate(fz, fm) {
      if (fm === 0) {
        return 0
      }
      return (fz / fm) * 100
    },
    getInitData() {
      this.childStep = []

      relateProduct({ idArr: this.relationSceneIdList }).then(res => {
        for (const element of res.data.content) {
          var step_item = {
            id: element.series,
            name: element.series,
            value: element.series,
            enabelTemp: true,
            status: 'inprogess'
          }
          this.childStep.push(step_item)
        }
        var step_last_item = {
          id: 'versionChangeConfirm',
          name: '版本选择结果确认',
          value: 'versionChangeConfirm',
          enabelTemp: true,
          status: 'todo'
        }
        this.childStep.push(step_last_item)
        this.handelStep = this.childStep[this.handelIndex]

        if (this.selectProductInfo) {
          this.viewSelectVersion = this.selectProductInfo

          this.stepSelectVersion = this.handelSelectVersion[this.childStep[this.handelIndex].id]
          for (const element of this.selectProductInfo) {
            if (element.serial === this.childStep[this.handelIndex].id) {
              this.stepPageSelectFeatureIds = element.selectFeatureIdList
            }
          }
        }
      })
    },
    viewSelectInfo(param) {
      this.functionParmas = param
      this.totalFeatureCont = param.totalFeatureCount
      this.selectFeatureCont = param.selectFunctionCount

      var chagne_version = this.calcVersionSupportRate(param.selectVersion, param)
      this.versionList = chagne_version

      if (this.handelIndex == 1 && this.childStep.length == 3) {
        console.log('xx')
      } else {
        this.versionList.push({ id: 'no_version_config', productVersion: '无需产品版本' })
      }
    },
    handelSelectProductVersion(versionItem) {
      delete this.handelSelectVersion[this.childStep[this.handelIndex].id]
      this.handelSelectVersion[this.childStep[this.handelIndex].id] = {
        totalFeatureCont: this.functionParmas.totalFeatureCount,
        selectFeatureCont: this.functionParmas.selectFunctionCount,
        versionId: versionItem.id,
        supportFeatureIds: versionItem.supportFeatureIds,
        unSupportFeatureids: versionItem.unSupportFeatureids,
        productVersion: versionItem.productVersion,
        selectType: 'HANDEL'
      }

      this.setpHandelSelectVersion = true
      this.stepSelectVersion = this.handelSelectVersion[this.childStep[this.handelIndex].id]
    },
    calcVersionSupportRate(selectVersion, all_data) {
      let max_rate = 0
      let maxt_rate_verion_id = null
      let version_all = null
      this.allSelectFeatureIds = []
      this.stepSelectVersion = {}
      if (!selectVersion) {
        return []
      }
      if (selectVersion && selectVersion.length === 0) {
        return selectVersion
      }
      for (const versionItem of selectVersion) {
        if (versionItem.id === 'no_version_config') {
          continue
        }
        versionItem.supportRate = this.getRate(versionItem.supportFeatureIds.length, this.selectFeatureCont)
        if (versionItem.supportRate >= max_rate) {
          max_rate_count = 1
          max_rate = versionItem.supportRate
          maxt_rate_verion_id = versionItem.id
          version_all = versionItem
        }
        const combinedArray = [...new Set([...this.allSelectFeatureIds, ...versionItem.supportFeatureIds])]
        this.allSelectFeatureIds = combinedArray
      }

      let max_rate_count = 0

      for (const versionItem of selectVersion) {
        if (versionItem.supportRate === max_rate) {
          max_rate_count = max_rate_count + 1
        }
      }

      for (const versionItem of selectVersion) {
        if (versionItem.id == maxt_rate_verion_id && max_rate_count === 1) {
          this.stepHasRecomment = true
          versionItem.hasRecommend = true
        } else {
          versionItem.hasRecommend = false
        }
      }

      if (this.handelSelectVersion[this.childStep[this.handelIndex].id]) {
        if (this.handelSelectVersion[this.childStep[this.handelIndex].id].selectType !== 'HANDEL') {
          this.handelSelectVersion[this.childStep[this.handelIndex].id] = {
            totalFeatureCont: all_data.totalFeatureCount,
            selectFeatureCont: all_data.selectFunctionCount,
            supportFeatureIds: version_all.supportFeatureIds,
            versionId: version_all.id,
            unSupportFeatureids: version_all.unSupportFeatureids,
            productVersion: version_all.productVersion,
            selectType: 'AUTO'
          }
        }
      } else {
        this.handelSelectVersion[this.childStep[this.handelIndex].id] = {
          totalFeatureCont: all_data.totalFeatureCount,
          selectFeatureCont: all_data.selectFunctionCount,
          versionId: maxt_rate_verion_id,
          supportFeatureIds: version_all.supportFeatureIds,
          unSupportFeatureids: version_all.unSupportFeatureids,
          productVersion: version_all.productVersion,
          selectType: 'AUTO'
        }
      }
      if (max_rate_count !== 1) {
        this.stepSelectVersion = {}
      } else {
        this.stepSelectVersion = this.handelSelectVersion[this.childStep[this.handelIndex].id]
      }

      return selectVersion
    },
    reloadData() {
      this.handelStep = this.childStep[this.handelIndex]
      this.stepValue = this.handelStep.value
      if (this.handelStep.id === 'versionChangeConfirm') {
        this.viewSelectVersion = []
        for (const key in this.handelSelectVersion) {
          var version = this.handelSelectVersion[key]
          if (version.versionId === 'no_version_config') {
            continue
          }
          version.serial = key
          this.viewSelectVersion.push(version)
        }
      }
      if (this.handelSelectVersion[this.stepValue]) {
        this.stepPageSelectFeatureIds = this.handelSelectVersion[this.stepValue].supportFeatureIds
      } else {
        this.stepPageSelectFeatureIds = []
      }
      this.parentSelectVersionId = []
      if (this.handelIndex !== 0) {
        for (let index = 0; index < this.handelIndex; index++) {
          var step = this.childStep[index]
          var versionx = this.handelSelectVersion[step.id]
          if (versionx.versionId !== 'no_version_config') {
            this.parentSelectVersionId.push(versionx.versionId)
          }
        }
      }

      // if (this.handelStep.id !== 'versionChangeConfirm') {
      //   this.$refs.select_function_table.reloadData()
      // }
    },
    goPreStep() {
      if (this.handelIndex !== 0) {
        this.activeStageNum = this.activeStageNum - 1
        this.handelIndex = this.handelIndex - 1
        this.reloadData()
      }
    },
    goNextStep() {
      if (!this.stepSelectVersion.versionId) {
        if (this.selectFeatureCont === 0) {
          this.$store.dispatch('OpenNotification', {
            message: '当前未选择产品功能，无法进行确定当前的产品版本，请手动选择！',
            type: 'error'
          })
          return
        } else if (this.versionList.length === 1 && this.versionList[0].id === 'no_version_config') {
          this.$store.dispatch('OpenNotification', {
            message:
              '当前产品系列，无对应的版本，或者前面步骤的版本限制当前产品系列的选择，请确认是否真的无配置版本，若确定，请选择【无需产品版本】',
            type: 'error'
          })
          return
        } else {
          this.$store.dispatch('OpenNotification', {
            message: '当前存在所选的功能多个产品版本支持比例一致的的情况，请手动选择产品版本！',
            type: 'error'
          })
        }
        return
      }

      if (this.stepHasRecomment || this.setpHandelSelectVersion) {
        if (this.handelIndex < this.childStep.length - 1) {
          this.activeStageNum = this.activeStageNum + 1
          this.handelIndex = this.handelIndex + 1
        }
        this.reloadData()
      } else {
        this.$store.dispatch('OpenNotification', {
          message: '当前存在所选的功能多个产品版本支持比例一致的的情况，请手动选择产品版本',
          type: 'error'
        })
        return
      }
    },
    onConfirm() {
      this.$emit('cb', { action: 'confirm', data: this.viewSelectVersion })
    },
    backToView() {
      // this.saveTempChildStepData()
      this.$emit('cb', { action: 'back', data: this.viewSelectVersion })
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(product-version-select) {
  height: 80vh;
  .sky-product-version-select-buttom {
    position: absolute;
    bottom: 12px;
    height: 88px;
    left: 50%;
    transform: translate(-50%, 50%);
  }
  .select-view {
    .select-info {
      text-align: center;
      .select-table-header {
        line-height: 36px;
      }
      .select-table-content {
        line-height: 28px;
      }
      .select-table-content:nth-child(n + 2) {
        border-top: 1px solid #ccc !important;
      }
    }
  }
  .select-change-step-content {
    min-height: 60%;
  }
  .select-change-step-bottom {
    height: 192px;
    width: 84vw;
    /* Chrome 和 Safari */
    ::-webkit-scrollbar {
      width: 3px;
    }

    ::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    ::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
    .select-version-info {
      overflow-x: auto;
      min-height: 10vh;

      .handel-active {
        background: #d0e3ef;
        border-color: #0052d9;
        border: 1px solid #0052d9;
      }
      .select-version-item {
        border: 1px solid #ccc;
        border-radius: 8px;
        position: relative;
        min-width: 20%;
        .select-recommend {
          position: absolute;
          right: 2px;
          font-size: 28px;
        }
        .select-version {
          line-height: 28px;
          text-align: center;
        }
        .select-support {
          height: 12px;
          position: relative;
          .select-support-vs {
            position: absolute;
            font-size: 20px;
          }
        }
        .select-support-cont {
          line-height: 28px;
          text-align: center;
        }
      }
    }
  }
  .select-change-step {
    .child-stage-progress {
      margin-top: 12px;
      margin-right: 24px;
      margin-bottom: 12px;
      height: 40px;
      .child-step-content {
        width: 90%;
      }
    }
    .navs {
      height: 32px;
      line-height: 32px;
      width: 100%;
      text-align: right;
    }

    .activite-line {
      height: 6px;
      line-height: 6px;
      width: 98%;
      text-align: right;
      margin-top: 8px;
    }

    .activite-line ul {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .activite-line .navs-item {
      content: '';
      flex: 1; /* 每个 item 占据相同的宽度 */
      min-width: 72px;
      line-height: 3px;
      height: 3px;
      // background: #1e9fff;
      position: relative;
      display: inline-block;
      margin-right: 12px;
    }

    .activite-line .active {
      background: #1e9fff;
    }

    .navs li {
      flex: 1; /* 每个 item 占据相同的宽度 */
      min-width: 72px;
      padding: 0px 10px 0 30px;
      line-height: 36px;
      font-size: 18px;
      margin-right: 12px;
      background: #dceefe;
      display: inline-block;
      color: #1e9fff /*#50abe4*/;
      position: relative;
      text-align: center;
    }

    .navs ul {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .navs li:after {
      content: '';
      display: block;
      border-top: 18px solid #dceefe;
      border-bottom: 18px solid #dceefe;
      border-left: 18px solid #fff;
      position: absolute;
      right: -17px;
      top: 0;
    }

    .navs li:after {
      content: '';
      display: block;
      border-top: 18px solid transparent;
      border-bottom: 18px solid transparent;
      border-left: 18px solid #dceefe;
      position: absolute;
      right: -17px;
      top: 0;
      z-index: 2;
    }

    .navs li:before {
      content: '';
      display: block;
      border-top: 18px solid #dceefe;
      border-bottom: 18px solid #dceefe;
      border-left: 18px solid #fff;
      position: absolute;
      left: 0px;
      top: 0;
    }

    .navs li:first-child {
      border-radius: 4px 0 0 4px;
      padding-left: 25px;
    }

    .navs li:last-child,
    .cssNavEnd {
      border-radius: 0px 4px 4px 0px;
      padding-right: 25px;
    }

    .navs li:first-child:before {
      display: none;
    }

    .navs li:last-child:after,
    .cssNavEnd:after {
      display: none;
    }

    .navs li.active {
      background: #1e9fff;
      color: #fff;
      cursor: pointer;
    }

    .navs li.active:after {
      border-left-color: #1e9fff;
    }

    .navs li.active:before {
      border-top: 18px solid #1e9fff;
      border-bottom: 18px solid #1e9fff;
    }

    .navs li.progress-done {
      background: #3bb113;
      color: #fff;
      cursor: pointer;
    }

    .navs li.progress-done:after {
      border-left-color: #3bb113;
    }

    .navs li.progress-done:before {
      border-top: 18px solid #3bb113;
      border-bottom: 18px solid #3bb113;
    }
  }
}
</style>
